import { render } from "./BadgeCard.vue?vue&type=template&id=806b3658"
import script from "./BadgeCard.vue?vue&type=script&lang=js"
export * from "./BadgeCard.vue?vue&type=script&lang=js"

import "./BadgeCard.vue?vue&type=style&index=0&id=806b3658&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__